import { Box, useMediaQuery, useTheme } from '@mui/material';
import { FC } from 'react';
import { IconButton } from '../../buttons/IconButton';
import { Grid } from '../../layout/grid/Grid';
import { Body2, H3, H6 } from '../../typography/TextStyles';
import { DrawerHeaderWideProps } from './model/DrawerHeaderWideProps';

export const DrawerHeaderWide: FC<DrawerHeaderWideProps> = ({ subHeader, header, onClose, ariaLabelClose }) => {
  const { breakpoints } = useTheme();
  const smDown = useMediaQuery(breakpoints.down('sm'));
  return (
    <Box border={1} borderTop={0} borderLeft={0} borderRight={0} borderColor="grey.300" py={{ xs: 2, md: 3 }}>
      <Grid container alignItems="center">
        <Grid item xs={10} pl={4}>
          {!smDown ? <Body2 color="textSecondary">{subHeader}</Body2> : null}
          {smDown ? (
            <H6 noWrap component="h2">
              {header}
            </H6>
          ) : (
            <H3 noWrap component="h2">
              {header}
            </H3>
          )}
        </Grid>
        <Grid item xs={2}>
          <Grid container justifyContent="flex-end">
            <IconButton
              data-testid="drawer-header-wide-close-button"
              mr={4}
              onClick={onClose}
              iconProps={{ name: 'close', size: 'large', color: 'black' }}
              aria-label={ariaLabelClose ?? 'Close drawer'}
            />
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};
